<template>
  <div>
    <v-btn
      v-if="action==='Update' && getArea"
      color="primary mt-1"
      medium
      text
      right
      @click="showDialog()"
    >
      <v-icon medium>{{action === 'Add' ? 'mdi-plus' : 'mdi-border-color' }}</v-icon>
    </v-btn>
    <v-btn
      v-if="action==='Add' && getArea"
      color="primary mt-1"
      medium
      absolute
      right
      fab
      @click="showDialog()"
    >
      <v-icon medium>{{action === 'Add' ? 'mdi-plus' : 'mdi-border-color' }}</v-icon>
    </v-btn>
    <v-dialog v-if="getArea" v-model="active" persistent max-width="60%">
      <v-card>
        <v-card-title>
          <span class="headline">{{title}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-text-field v-model="form.title" label="Title*" required></v-text-field>
            <v-text-field v-model="form.videoId" label="Youtube Video ID*" required></v-text-field>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-btn v-if="action === 'Update'" color="error" text @click="deleteData()">Delete</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="active = false">Close</v-btn>
          <v-btn color="blue darken-1" text @click="submit()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    action: {
      type: String,
      required: true
    },
    mydata: {
      type: Object,
      required: false
    }
  },
  computed: {
    ...mapGetters("global", ["getArea"])
  },
  data: () => ({
    active: false,
    title: "",
    form: {
      title: "",
      videoId: "",
      id: null
    }
  }),
  methods: {
    showDialog() {
      if (this.action === "Update") {
        this.title = "Update Video";
        this.form = {
          title: this.mydata.Title,
          videoId: this.mydata.VideoId,
          id: this.mydata.Id
        };
      } else {
        this.title = "Add New Video";
        this.form = {
          title: "",
          videoId: "",
          id: null
        };
      }
      this.active = true;
    },
    async submit() {
      try {
        if (this.action === "Add") {
          await this.$emit("add", this.form);
        } else {
          await this.$emit("update", this.form);
        }
        this.active = false;
      } catch (error) {
        console.log(error);
      }

      this.active = false;
    },
    deleteData() {
      this.$emit("delete", this.form.id);
      this.active = false;
    }
  }
};
</script>